import React, {useState, useEffect} from 'react';
import {isMobile} from 'react-device-detect';
import MainTitleComponent from '../Headline/MainTitleComponent';
import BlockHeadlineComponent from '../Headline/BlockHeadlineComponent';
import SubscriberItemWithButtonComponent from './SubscriberItemWithButtonComponent';
import ConfirmationComponent from './ConfirmationComponent';
import SelectCellularPackageComponent from './SelectCellularPackageComponent';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import errors from '../Errors/errors';
import {stepEnum, packageSelectionStatus} from '../ChangePricePlanConsts';
import {
  gAChangePPSelectPackageLimited,
  gAChangePPOrderBtnClickLimited,
  gAChangePPOrderBtnClick,
  gAChangePPContinueBtnClickLimited,
  gAChangePPContinueBtnClick,
} from '../reports/gaReports';
import {gtag4} from '../../../../utilities/analytics/tracking';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import {dwhContinueButtonClick, dwhSelectPackagesDisplay, dwhSelectPackagesOrderButtonClick} from '../reports/dwhReports';
import {removeHTMLTags} from '../../../../utilities/StringHelpers/StringHelpers';
const SelectingFlowComponent = ({props, showCurrentPackage}) => {
  const [saveConfirmStep, setSave] = useState(false);
  const [titleReselectPackage, setTitle] = useState('');
  const [btnStatus, handleBtnStatus] = useState(true);
  const newOfferId = props.data.selectedAccount?.newPackage?.offerID;
  const currentOfferId = props.data.selectedAccount?.pricePlan;
  const subscriber = props.userData.loginData?.userDetails.contactNumber;
  const pageURL = window.location.href;
  const customerName = `${props.userData.loginData?.userDetails?.firstName} ${props.userData.loginData?.userDetails?.lastName}`;
  const id = props.userData.loginData?.userDetails?.IDNumber;

  //back logic
  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (props.data.selectedAccountExtendedData) {
          setTimeout(() => {
            if (
              props.data.selectCellularPackageProcess?.status == packageSelectionStatus.SELECTING ||
              props.data.selectCellularPackageProcess?.status == packageSelectionStatus.MULTI_SELECT
            ) {
              setSave(true);
              if (props.data.allCellularPackagesForAccountData?.length > 1) {
                props.saveToHistory('selecting');
              } else {
                props.saveToHistory();
              }
            } else if (props.data.selectCellularPackageProcess?.status == packageSelectionStatus.CONFIRMATION) {
              if (props.data.allCellularPackagesForAccountData.length > 1) {
                props.saveToHistory('confirm');
              } else {
                if (props.data.selectedMarketPackage) {
                  props.saveToHistory();
                } else {
                  props.saveToHistory('confirm');
                }
              }
              setSave(false);
            }
          }, 2500);
        }
      }
    },
    [props.data.selectCellularPackageProcess?.status, props.data.selectedAccountExtendedData]
  );

  useEffect(() => {
    if (typeof window.scrollTo === 'function') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [props.data.selectCellularPackageProcess?.status]);

  useEffect(() => {
    validateButton();
  }, [props.data.selectedAccountExtendedData?.associatedSubscriberList]);

  useEffect(() => {
    if (props.data.selectedAccount && !props.data.selectedAccount.newPackage) {
      if (props.data.selectedAccountExtendedData?.banlvl_pp_limited == 'Y') {
        if (props.data.selectedAccountExtendedData.associatedSubscriberList?.length > 0) {
          if (props.userData.loginData.isFullAuthenticated || props.userData.loginData.isOtpExtendedAuthenticated) {
            gAChangePPSelectPackageLimited(props.data.selectedAccountExtendedData.associatedSubscriberList.length);
            props.setHeadlineText({
              mainText: 'שניה לפני שנעדכן את החבילה!',
              description: `שמנו לב שמנוי ${props.data.selectedAccount.subscriberNo.replace(
                /^(.{3})(.*)$/,
                '$1-$2'
              )} נמצא בחבילה משותפת עם מנויים נוספים
              <br/>
              <br/>
              יש לעדכן את החבילה החדשה גם למנויים הבאים`,
            });
            props.activateSelectPage({status: packageSelectionStatus.MULTI_SELECT});
          }
        } else {
          props.setError({text: errors.server_error, reason: 'server_error'});
          props.handleCurrentStep({step: stepEnum.CALL_BACK, error: true});
        }
      } else {
        props.setHeadlineText({
          mainText: props.data.selectedAccount.subscriberNo.replace(/^(.{3})(.*)$/, '$1-$2'),
          small: 'מנוי',
        });
        if (props.data.selectedAccount.isKosher) {
          //set kosher packages
          if (props.data.selectedMarketPackage) {
            //show message
            setTitle(`שמנו לב שיש לך קו כשר,</br>
            נשמח להציע לך חבילות מתאימות לקוים כשרים.
            `);
          }
          props.setPackagesList(props.iContent.kosherPricePlansContentArea);
          props.setDiscountedPackagesList(getDiscountedPackage(true, props.data.selectedAccount.pricePlan));
          props.activateSelectPage({status: packageSelectionStatus.SELECTING});
        } else if (props.data.selectedAccount.accountMidType == '+' && props.data.selectedMarketPackage) {
          if (props.data.selectedMarketPackage) {
            //show message
            setTitle(`שמנו לב שיש לך מנוי של בן משפחה עסקי,</br>
            נשמח להציע לך חבילות מתאימות.
            `);
          }
          props.activateSelectPage({status: packageSelectionStatus.SELECTING});
        } else {
          //set regular packages
          if (props.data.selectedMarketPackage) {
            orderEvent(props.data.selectedMarketPackage);
            props.activateSelectPage({status: packageSelectionStatus.CONFIRMATION});
          } else {
            props.setPackagesList(props.iContent.pricePlansContentArea);
            props.setDiscountedPackagesList(getDiscountedPackage(false, props.data.selectedAccount.pricePlan));
          }
        }
        if (!props.data.selectedMarketPackage) {
          //DWH
          dwhOnDisplay(props.data.selectedAccount.subscriberNo);
        }
      }
    }
  }, [props.data.selectedAccount]);

  const getDiscountedPackage = (isKosher, currentPricePlan) => {
    let disPackage = null;
    const packagesList = isKosher
      ? props.iContent.discountedAndKosherPricePlansContentArea.expandedValue
      : props.iContent.discountedPricePlansContentArea.expandedValue;
    if (props.data.selectedAccountExtendedData != null) {
      if(props.data.selectedAccountExtendedData.quatro_soc != null) {
        if (
          props.data.selectedAccountExtendedData.quatro_soc.trim() != '' &&
          currentPricePlan.trim() != props.data.selectedAccountExtendedData.quatro_soc.trim()
        ) {
          disPackage = packagesList?.find((plan) => plan.offerID.value.trim() == props.data.selectedAccountExtendedData.quatro_soc.trim());
          if (disPackage != undefined) {
            return disPackage;
          }
        }
        if (props.data.selectedAccountExtendedData.quatro_soc.trim() == '') {
          disPackage = packagesList?.find(
            (pack) => pack.isRecommendedForChangePricePlan.value != null && pack.isRecommendedForChangePricePlan.value
          );
          if (disPackage != null) {
            return disPackage;
          }
        }
      }
    }
    return disPackage;
  };

  function getPackages() {
    if (props.data.selectedAccount?.accountMidType == '+' || props.userData.loginData?.magicLinkParameters) {
      return null;
    }
    return props.data.packagesList;
  }

  function getDiscountedPackages() {
    if (props.data.selectedAccount?.accountMidType == '+') {
      return null;
    }
    return props.data.discountedPackages;
  }

  function getFamilyPackages() {
    if(props.data.magicLinkOrgData)
      return props.data.magicLinkPackList;
    else if (
      props.organizationData?.organizationCodeList?.value?.length > 0 &&
      props.organizationData?.specialPackagesCellularList?.expandedValue?.length > 0
    ) {
      return props.organizationData.specialPackagesCellularList;
    } else return null;
  }

  const activateSelecting = (account) => {
    if (account.isKosher) {
      //set kosher packages
      props.setPackagesList(props.iContent.kosherPricePlansContentArea);
      props.setDiscountedPackagesList(getDiscountedPackage(true, account.pricePlan));
    } else {
      //set regular packages
      props.setPackagesList(props.iContent.pricePlansContentArea);
      props.setDiscountedPackagesList(getDiscountedPackage(false, account.pricePlan));
    }
    props.setHeadlineText({
      mainText: account.subscriberNo.replace(/^(.{3})(.*)$/, '$1-$2'),
      description: '',
      small: 'מנוי',
    });

    props.activateSelectPage({status: packageSelectionStatus.SELECTING, activeNumber: account.subscriberNo});
    if (!props.data.selectedMarketPackage) {
      dwhOnDisplay(account.subscriberNo);
    }
  };

  const orderEvent = (newPackage) => {
    let phoneNumber;
    if (props.data.selectedAccountExtendedData?.associatedSubscriberList?.length > 0) {
      phoneNumber = props.data.selectCellularPackageProcess?.activeNumber;
      gAChangePPOrderBtnClickLimited();
      const newData = props.data.selectedAccountExtendedData?.associatedSubscriberList?.map((account) => {
        if (account.subscriberNo == props.data.selectCellularPackageProcess?.activeNumber) {
          return {
            ...account,
            newPackage: newPackage,
            checked: false,
          };
        }
        return account;
      });

      props.saveSelectedDataForFixedPriceAccount(newData);
      props.setHeadlineText({
        mainText: 'שניה לפני שנעדכן את החבילה!',
        description: `שמנו לב שמנוי ${props.data.selectedAccount.subscriberNo.replace(
          /^(.{3})(.*)$/,
          '$1-$2'
        )} נמצא בחבילה משותפת עם מנויים נוספים
        <br/>
        <br/>
        יש לעדכן את החבילה החדשה גם למנויים הבאים`,
      });
      props.activateSelectPage({status: packageSelectionStatus.MULTI_SELECT});
    } else {
      phoneNumber = props.data.selectedAccount.subscriberNo;
      //GA 4
      if (!props.data.selectedMarketPackage) {
        gtag4({
          event: 'CellPackUpdateP2_Step5_PackageClick',
          button: newPackage.buttonText,
          step: '5',
          action: 'PackageClick',
          package: removeHTMLTags(newPackage.title),
          badge: newPackage.benefitTitle,
        });

        //DWH
        const newOfferId = newPackage.offerID;
        dwhSelectPackagesOrderButtonClick({newOfferId, currentOfferId, subscriber, pageURL, customerName, id, phoneNumber});
      }
      gAChangePPOrderBtnClick(); //GA old

      props.setAccountDataWithNewSelectedPackage({newPackage});
      props.setHeadlineText({mainText: 'פרטי החבילה', description: 'קחו רגע לאשר את פרטי החבילה החדשה שבחרתם', small: ''});
      props.activateSelectPage({status: packageSelectionStatus.CONFIRMATION});
    }
  };
  const validateButton = () => {
    if (props.data.selectedAccountExtendedData?.associatedSubscriberList?.length > 0) {
      const newPackagesCount = props.data.selectedAccountExtendedData?.associatedSubscriberList.filter((acc) => acc.newPackage != null);
      if (newPackagesCount.length == props.data.selectedAccountExtendedData?.associatedSubscriberList.length) {
        handleBtnStatus(true);
      } else {
        handleBtnStatus(false);
      }
    } else {
      handleBtnStatus(true);
    }
  };

  const continueProcess = () => {
    if (saveConfirmStep) {
      props.saveToHistory('confirm');
    } else props.saveToHistory();
    let phoneNumber;
    if (props.data.selectedAccountExtendedData != null && props.data.selectedAccountExtendedData.banlvl_pp_limited == 'Y') {
      gAChangePPContinueBtnClickLimited();

      props.saveSelectedDataForFixedPriceAccount(props.data.selectedAccountExtendedData.associatedSubscriberList);
      //DWH
      phoneNumber = props.data.selectedAccountExtendedData.associatedSubscriberList
        .map((sub) => {
          return sub.subscriberNo;
        })
        .join(',');
      dwhContinueButtonClick({newOfferId, currentOfferId, subscriber, pageURL, customerName, id, phoneNumber});
    } else {
      gAChangePPContinueBtnClick(); //GA old
      //GA 4
      if (!props.data.selectedMarketPackage) {
        gtag4({
          event: 'CellPackUpdateP2_Step11_UpdatePackageContinueButton',
          button: 'אפשר להתקדם',
          step: '11',
          action: 'UpdatePackageContinueButton',
          title:
            props.data.selectedAccountExtendedData?.associatedSubscriberList?.length > 0
              ? props.data.headlineText.mainText
              : 'בואו נוודא שכל הפרטים נכונים',
          package: props.data.selectedAccount?.newPackage?.offerID,
        });
      } else {
        gtag4({
          event: 'CellPackUpdateP1_Step8_UpdatePackageButton',
          button: 'אפשר להתקדם',
          step: '8',
          action: 'UpdatePackageButton',
          title:
            props.data.selectedAccountExtendedData?.associatedSubscriberList?.length > 0
              ? props.data.headlineText.mainText
              : 'בואו נוודא שכל הפרטים נכונים',
        });
      }
      //DWH
      phoneNumber = props.data.selectedAccount.subscriberNo;
      dwhContinueButtonClick({newOfferId, currentOfferId, subscriber, pageURL, customerName, id, phoneNumber});
    }

    props.handleCurrentStep({step: stepEnum.CONTACT_FORM, error: false});
  };
  function dwhOnDisplay(phoneNumber) {
    dwhSelectPackagesDisplay({currentOfferId, subscriber, pageURL, customerName, id, phoneNumber});
  }

  return (
    <div
      className={` ${props.data.selectCellularPackageProcess?.status != packageSelectionStatus.SELECTING ? 'max-width-440 m-auto' : ''}`}>
      {!props.data.error && (
        <>
          <div className={`${!props.data.getSelectedSubscriberDetailsCompleted ? 'hidden' : ''}`}>
            <>
              {props.data.selectCellularPackageProcess?.status == packageSelectionStatus.MULTI_SELECT && (
                <>
                  <div className={`multiselect-container m-auto text-center select-flow`}>
                    {props.data.selectedAccountExtendedData?.associatedSubscriberList?.length > 0 && (
                      <>
                        <div className={` ${isMobile ? 'w-100 m-0' : ''}`}>
                          <div className='mr-auto ml-auto'>
                            <BlockHeadlineComponent
                              currentStep={props.data.currentStep}
                              mainText={props.data.headlineText.mainText}
                              description={props.data.headlineText.description}
                            />
                          </div>
                        </div>

                        <div className={`background-container subscribers-flow`}>
                          {props.data.selectedAccountExtendedData?.associatedSubscriberList?.map((account, index) => {
                            if (account.newPackage == null) {
                              return (
                                <SubscriberItemWithButtonComponent
                                  key={index}
                                  account={account}
                                  activateSelecting={activateSelecting}
                                  showCurrentPackage={showCurrentPackage}
                                />
                              );
                            } else {
                              return (
                                <ConfirmationComponent
                                  key={index}
                                  account={account}
                                  checked={account?.checked}
                                  activateSelecting={activateSelecting}
                                  limited={true}
                                  showCurrentPackage={showCurrentPackage}
                                  isFromPackage={props.data.selectedMarketPackage}
                                  pageTitle={props.data.headlineText.mainText}
                                  loginData={props.userData.loginData}
                                  displayPackagesLinkTxt={props.iContent.displayPackagesLinkTxt.value}
                                />
                              );
                            }
                          })}
                        </div>
                      </>
                    )}
                  </div>
                </>
              )}
              {props.data.selectCellularPackageProcess?.status == packageSelectionStatus.CONFIRMATION &&
                props.data.selectedAccount?.newPackage && (
                  <>
                    <MainTitleComponent title={'בואו נוודא שכל הפרטים נכונים'} />
                    <div className={`background-container subscribers-flow`}>
                      <ConfirmationComponent
                        account={props.data.selectedAccount}
                        checked={props.data.selectedAccount?.checked}
                        activateSelecting={activateSelecting}
                        limited={false}
                        showCurrentPackage={showCurrentPackage}
                        isFromPackage={props.data.selectedMarketPackage}
                        pageTitle={'בואו נוודא שכל הפרטים נכונים'}
                        loginData={props.userData.loginData}
                        displayPackagesLinkTxt={props.iContent.displayPackagesLinkTxt.value}
                      />
                    </div>
                  </>
                )}

              {props.data.selectCellularPackageProcess?.status == packageSelectionStatus.SELECTING && (
                <>
                  {props.data.selectCellularPackageProcess?.activeNumber && (
                    <div className='multiselect-select-package-headline'>
                      <BlockHeadlineComponent
                        currentStep={props.data.currentStep}
                        mainText={`עדכון חבילה למנוי <br/> ${props.data.selectCellularPackageProcess?.activeNumber}`}
                      />
                    </div>
                  )}
                  <div className={`select-cellular-container `}>
                    <SelectCellularPackageComponent
                      orderEvent={orderEvent}
                      packages={getPackages()}
                      discountedPackage={getDiscountedPackages()}
                      familyPackages={getFamilyPackages()}
                      limited={props.data.selectedAccountExtendedData?.banlvl_pp_limited == 'Y' ? true : false}
                      activeNumber={props.data.selectCellularPackageProcess?.activeNumber}
                      saveToHistory={props.saveToHistory}
                      organizationName={props.organizationData?.name}
                      balance={props.data.selectedAccountExtendedData?.balance}
                      used={props.data.selectedAccountExtendedData?.used}
                      titleReselectPackage={titleReselectPackage}
                      startedFromPackage={props.data.selectedMarketPackage}
                    />
                  </div>
                </>
              )}
            </>
          </div>

          {(props.data.selectCellularPackageProcess?.status == packageSelectionStatus.CONFIRMATION ||
            props.data.selectCellularPackageProcess?.status == packageSelectionStatus.MULTI_SELECT) && (
            <div className={`${isMobile ? '' : 'm-auto'} confirmation-btn text-center ${btnStatus ? '' : 'disabled'}`}>
              <BtnSubmit text='אפשר להתקדם' onclick={() => (btnStatus ? continueProcess() : null)} />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default SelectingFlowComponent;
